<div class="py-[30px]">
  <div>
    <div class="flex flex-row items-center justify-between">
      <div class="v4-layout-form mr-[20px] !mb-[0]">
        <div class="v4-layout-form-title">{{ "property-property_detail-pricing-ratio_html_pr_title" | translate }}</div>
        <div class="v4-layout-form-desc">
          {{ "property-property_detail-pricing-ratio_html_pr_alert" | translate }}
        </div>
      </div>

      <nz-switch [(ngModel)]="enablePriceRatio" (ngModelChange)="onPrStatusChange()"></nz-switch>
    </div>

    @if (enablePriceRatio) {
      <div class="flex flex-row items-center justify-between mt-3">
        <div class="w-[300px] mr-3 flex flex-row items-center">
          <img src="/assets/v4/icon-house-color.svg" class="w-[16px] mr-[8px]" alt="" />
          <span>
            {{
              (isHouse()
                ? "property-property_detail-pricing-ratio_html_price_of_this_pro"
                : "property-property_detail-pricing-ratio_html_price_of_this_rt"
              ) | translate
            }}
          </span>
        </div>
        <div>
          <nz-input-group nzSuffix="%" nzSize="large" class="w-[100px]">
            <input type="number" nz-input [ngModel]="100" [disabled]="true" />
          </nz-input-group>
        </div>
      </div>
      @for (
        item of listOfPriceRatio?.slice(
          0,
          showMorePriceRatioChannel() ? listOfPriceRatio.length : showMoreListingsLimit
        );
        track $index
      ) {
        <div class="flex flex-row items-center justify-between mt-3">
          <div class="mr-[30px] flex flex-row items-center flex-1">
            <img class="w-[16px] mr-[8px]" [src]="(item.thirdparty_type | thirdparty)?.icon_color_bg" alt="" />
            <div class="ellipsis-line-2" [title]="item.title">{{ item.title }}</div>
          </div>
          <div>
            <nz-input-group nzSuffix="%" nzSize="large" class="w-[100px]">
              @if (item.readonly) {
                <input type="text" nz-input value="N/A" disabled />
              } @else {
                <input type="number" nz-input [(ngModel)]="item.ratio" />
              }
            </nz-input-group>
          </div>
        </div>
      }

      @if (listOfPriceRatio?.length > showMoreListingsLimit) {
        <div class="mt-3">
          <a href="javascript:void(0)" (click)="showMorePriceRatioChannel.set(!showMorePriceRatioChannel())">{{
            showMorePRCText()
          }}</a>
        </div>
      }

      <div class="mt-6">
        <button nz-button nzType="primary" nzSize="large" (click)="onSavePriceRatio()">
          {{ "word.save" | translate }}
          <!-- Save -->
        </button>
      </div>
    }
  </div>

  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div class="v4-layout-form mr-[20px] !mb-[0]">
        <div class="v4-layout-form-title">
          {{ "property-property_detail-pricing-ratio_html_spo_title" | translate }}
        </div>
        <div class="v4-layout-form-desc">
          {{ "property-property_detail-pricing-ratio_html_spo_alert" | translate }}
        </div>
      </div>
    </div>

    <div class="flex flex-row items-center justify-between mt-[16px]">
      <div class="w-[300px] mr-3 h-height-lg"></div>
      <div class="flex flex-row items-center">
        <div class="w-[80px] mr-6 h-height-lg">
          {{ "property-property_detail-pricing-ratio_html_spo_price" | translate }}
        </div>
        <div class="w-[80px] mr-6 h-height-lg">
          {{ "property-property_detail-pricing-ratio_html_spo_restri" | translate }}
        </div>
      </div>
    </div>

    @for (
      item of listOfPriceOptout.slice(0, showMorePriceOptout() ? this.listOfPriceOptout.length : showMoreListingsLimit);
      track $index
    ) {
      <div class="flex flex-row items-center justify-between mt-3">
        <div class="mr-[30px] flex flex-row items-center flex-1">
          <img class="w-[16px] mr-[8px]" [src]="(item.thirdparty_type | thirdparty)?.icon_color_bg" alt="" />
          <div class="ellipsis-line-2" [title]="item.title">{{ item.title }}</div>
        </div>
        <div class="flex flex-row items-center">
          <div class="w-[80px] mr-6 h-height-lg">
            <label nz-checkbox [(ngModel)]="item.price"></label>
          </div>
          <div class="w-[80px] mr-6 h-height-lg">
            <label nz-checkbox [(ngModel)]="item.restriction"></label>
          </div>
        </div>
      </div>
    }

    @if (listOfPriceOptout?.length > showMoreListingsLimit) {
      <div class="mt-3">
        <a href="javascript:void(0)" (click)="showMorePriceOptout.set(!showMorePriceOptout())">
          {{ showMorePOText() }}
        </a>
      </div>
    }

    <div class="mt-6">
      <button nz-button nzType="primary" nzSize="large" (click)="onSavePriceOptout()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
